import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const useEpikBoxPri = (
  numberOfChannel,
  dchannel,
  bchannel,
  channelRange,
  echoheckBox,
  defaultPri,
  priFailovers,
  sortedPriList
) => {
  const priSettings = useSelector(state => state.AppState.priSipData?.priSettingData);

  const [dropDownStates, setDropDownStates] = useState({
    framing: priSettings?.framing || 'd4',
    lineCode: priSettings?.lineCode || 'b8zs',
    timeAndSource: priSettings?.timeAndSource || 'internal',
    switchType: priSettings?.switchType || 'national',
    echoCancellationType: 'mg2',
  });

  useEffect(() => {
    if (defaultPri) {
      setDropDownStates({
        framing: 'd4',
        lineCode: 'b8zs',
        timeAndSource: 'internal',
        switchType: 'national',
        echoCancellationType: 'mg2',
      });
    }
  }, [defaultPri]);

  const handleDropDownStates = useCallback(
    (name, value) => {
      setDropDownStates({ ...dropDownStates, [name]: value });
    },
    [dropDownStates],
  );

  const produceState = useCallback(() => {
    let priFailoversList = [];
    if (sortedPriList?.length === priFailovers?.length) {
      priFailoversList = sortedPriList;
    } else {
      priFailoversList = priFailovers;
    }
    return {
      ...dropDownStates,
      channels: numberOfChannel,
      dChannel: dchannel,
      bChannels: bchannel,
      echoChannels: channelRange,
      echoCancellation: echoheckBox,
      priFailovers: priFailoversList,
    };
  }, [dropDownStates, numberOfChannel, dchannel, bchannel, channelRange, echoheckBox, priFailovers, sortedPriList]);

  return {
    produceState,
    dropDownStates,
    handleDropDownStates,
  };
};

export default useEpikBoxPri;
